import { createFileRoute } from "@tanstack/react-router";
import { pageTitle } from "@/components/document-title";
import { AddressPage } from "@/features/onboarding/pages/address-page";

export const Route = createFileRoute("/onboarding/_guarded/address")({
	head: () => pageTitle("Your Home Address"),
	component: AddressPage,
});
